import React from "react"
import Showcase from "../components/Showcase"
import { Animator } from "react-ame-components"
import playing from "../assets/lottie/playing.json"

export class AnimatorExample extends React.Component {
  render() {
    return (
      <Showcase
        centerGrid
        title="Componente Animator"
        description="Este componente serve para exibir uma animação configurada através de
      um arquivo lottie.">
        <Animator
          animationData={playing}
          width="250px"
        />
      </Showcase>
    )
  }
}
